import { Filter } from '@elderbyte/ngx-starter'

export class StorageNodeFilterBuilder {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public static IDS_KEY = 'ids'
  public static FACILITY_KEY = 'facility'

  private _ids: string[]

  private _facility: string

  /***************************************************************************
   *                                                                         *
   * Static Builders                                                         *
   *                                                                         *
   **************************************************************************/

  public static ids(...ids: string[]): Filter {
    return this.start()
      .ids(...ids)
      .build()[0]
  }

  public static start(): StorageNodeFilterBuilder {
    return new StorageNodeFilterBuilder()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public ids(...ids: string[]): StorageNodeFilterBuilder {
    this._ids = ids
    return this
  }

  public facility(facility: string): StorageNodeFilterBuilder {
    this._facility = facility
    return this
  }

  public build(): Filter[] {
    const filters: Filter[] = []

    if (this._ids) {
      filters.push(new Filter(StorageNodeFilterBuilder.IDS_KEY, this._ids))
    }

    if (this._facility) {
      filters.push(new Filter(StorageNodeFilterBuilder.FACILITY_KEY, this._facility))
    }

    return filters
  }
}
